import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/messages/")({
  staticData: { title: "Messages" },
  head: () => ({
    title: "My Coaching Conversations | Dream Coach Match",
    meta: [
      {
        name: "description",
        content:
          "Access all your coaching conversations and stay connected with your coaches.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
